import Vue from "vue";
const vm = new Vue()

export const addBanking = async (shopId, {
    bankCode,
    number,
    name
}) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .post( vm.$API_URL + `/shop/bank`, 
        {
            shop_id: Number(shopId),
            account_bank: bankCode,
            account_id: number,
            name: bankCode === '999' ? 'พร้อมเพย์' : name
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(res.data)
        });
    });
};

export const updateBanking = async (shopId, bankId , {
    bankCode,
    number,
    name
}) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/shop/bank/${bankId}`, 
        {
            shop_id: Number(shopId),
            account_bank: bankCode,
            account_id: number,
            name: bankCode === '999' ? 'พร้อมเพย์' : name
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(res.data)
        });
    });
};
